import React, { PureComponent } from 'react';
import { Modal, Service } from '../index';
import ServiceForm from '../../forms/service-form/ServiceForm';


class Services extends PureComponent {


  state = { isOpen: false };

  constructor(props) {
    super(props);
    this.NO_ID = -1;
  }

  toggleOpenModal() {
    this.setState({ isOpen: !this.state.isOpen });
  }

  handlerChange(index) {
    this.setState({ serviceData: index === this.NO_ID ? {} : this.props.fields.get(index) });

    this.toggleOpenModal();
  }

  render() {
    const { services: { list = [] } } = this.props;
    console.log("---->", list);
    return (
      <div className="planet-events">
        <div className="row">
          {
            list.map((values, index) => {
              console.log("AQUI-----> ", values)
              return (
                <div key={index} className="col-xs-6 col-md-3">
                  <Service
                    handlerRemove={this.removeHandler}
                    handlerChange={this.handlerChange.bind(this, index)}
                    service={values}/>
                </div>
              )
            })
          }
          <div className="col-xs-6 col-md-3">
            <Service
              handlerChange={this.handlerChange.bind(this, this.NO_ID)}
              service={null}/>
          </div>
        </div>

        <Modal
          toogle={this.toggleOpenModal.bind(this)}
          isOpen={this.state.isOpen}>
          <ServiceForm toogle={this.toggleOpenModal.bind(this)} values={this.state.serviceData}/>
        </Modal>
      </div>
    );
  }
}

Services.propTypes = {};
Services.defaultProps = {};

export default Services;



// WEBPACK FOOTER //
// ./src/components/services/Services.js